import { i18n } from '@/i18n'
import store from '@/store'
import * as validate from './validation'

export function fieldValidation (formObject) {
  let valid = 0
  let validationField = ''

  // for multiple field validations check the error status, only the first error is relevant
  Object.keys(formObject).forEach(field => {
    formObject[field].error = ''
    let validationFieldStatus = true
    formObject[field].validate.forEach(validation => {
    // eslint-disable-next-line no-empty
      if (validationField === field && validationFieldStatus === false) {
      } else {
        const validationResult = validate.useValidation(formObject, field, validation)
        if (!validationResult.status) {
          formObject[field].error = validationResult.content
          validationFieldStatus = false
          valid++
        }
      }
      validationField = field
    })
  })
  return valid
}

export function useValidation (formObject, field, validation) {
  const reEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  const reSpecialChars = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/
  let content = formObject[field].content
  if (formObject[field].rtEditor) {
    content = document.getElementById(formObject[field].ref).innerText
  }
  const userLocale = store.state.user.settings?.language

  switch (validation) {
    case 'empty':
      if (content.toString().trim() !== '') {
        return { content: '', status: true }
      } else {
        return { content: i18n?.global.t('error.0101', userLocale), status: false }
      }

    case 'length':
      if (content.toString().length <= formObject[field].maxLength) {
        return { content: '', status: true }
      } else {
        return { content: i18n?.global.t('error.0102', userLocale, { maxLength: formObject[field].maxLength }), status: false }
      }

    case 'validFrom':
      if (content.toString().trim() === '') {
        return { content: '', status: true }
      } else {
        if ((content.toString().split('-')[0].length <= 4) && (content.toString().split('-')[0] >= '2000') && (content.toString().split('-')[0] <= '2099')) {
          return { content: '', status: true }
        } else {
          return { content: i18n?.global.t('error.0107', userLocale), status: false }
        }
      }

    case 'validFromParent':
      if (content.toString().trim() === '' || formObject.validFromParent.content === '') {
        return { content: '', status: true }
      } else {
        if ((content.toString() >= formObject.validFromParent.content)) {
          return { content: '', status: true }
        } else {
          return { content: i18n?.global.t('error.0112', userLocale), status: false }
        }
      }

    case 'validToParent':
      if (content.toString().trim() === '' || formObject.validToParent.content === '') {
        return { content: '', status: true }
      } else {
        if ((content.toString() <= formObject.validToParent.content)) {
          return { content: '', status: true }
        } else {
          return { content: i18n?.global.t('error.0113', userLocale), status: false }
        }
      }

    case 'validTo':
      if (content.toString().trim() === '') {
        return { content: '', status: true }
      } else {
        if ((content.toString().split('-')[0].length <= 4) && (content.toString().split('-')[0] >= '2000') && (content.toString().split('-')[0] <= '2099')) {
          if (formObject.validFrom.content.toString() !== '' && formObject.validTo.content.toString() < formObject.validFrom.content.toString()) {
            return { content: i18n?.global.t('error.0108', userLocale), status: false }
          }
          return { content: '', status: true }
        } else {
          return { content: i18n?.global.t('error.0107', userLocale), status: false }
        }
      }

    case 'email':
      if (reEmail.test(content.toString().trim())) {
        return { content: '', status: true }
      } else {
        return { content: i18n?.global.t('error.0103', userLocale), status: false }
      }

    case 'emailConfirmation':
      if (formObject.email.content.toString().trim() === '' || content.toString().trim() === formObject.email.content.toString().trim()) {
        return { content: '', status: true }
      } else {
        return { content: i18n?.global.t('error.0104', userLocale), status: false }
      }

    case 'password':
      if (content.trim().length >= 8 && /\d/.test(content) && /[a-zA-Z]/.test(content) && reSpecialChars.test(content)) {
        return { content: '', status: true }
      } else {
        return { content: i18n?.global.t('error.0105', userLocale), status: false }
      }

    case 'passwordConfirmation':
      if (formObject.password.content === formObject.passwordConfirmation.content) {
        return { content: '', status: true }
      } else {
        return { content: i18n?.global.t('error.0106', userLocale), status: false }
      }

    case 'maxValue':
      if (content.toString().trim() <= formObject[field].max) {
        return { content: '', status: true }
      } else {
        return { content: i18n?.global.t('error.0109', userLocale, { maxLength: formObject[field].max }), status: false }
      }
  }
}

export function timeDimValidation (formObject) {
  const userLocale = store.state.user.settings?.language
  let valid = true

  if (formObject.timeDimInput.content === 'Q' || formObject.timeDimInput.content === 'Y') {
    if (formObject.timeDimDisplay.content === 'M') {
      formObject.timeDimDisplay.error = i18n?.global.t('error.0110', userLocale)
      valid = false
    }
  }
  if (formObject.timeDimInput.content === 'Y') {
    if (formObject.timeDimDisplay.content === 'Q' || formObject.timeDimDisplay.content === 'M') {
      formObject.timeDimDisplay.error = i18n?.global.t('error.0110', userLocale)
      valid = false
    }
  }

  return valid
}

export function relationshipValidation (formObject, selectedStrategy) {
  const userLocale = store.state.user.settings?.language
  let valid = 0

  if (formObject.relationship.type.content === 'objective') {
    const ObjectiveUuid = formObject.relationshipObjective.objectiveParentId.content
    selectedStrategy.relationships.forEach((relationship) => {
      if (relationship.objectiveUuid === ObjectiveUuid) {
        valid = 1
        formObject.relationshipObjective.objectiveParentId.error = i18n?.global.t('error.0111', userLocale)
      }
    })
  }
  if (formObject.relationship.type.content === 'project') {
    const ObjectiveUuid = formObject.relationshipProject.projectParentId.content
    selectedStrategy.relationships.forEach((relationship) => {
      if (relationship.projectUuid === ObjectiveUuid) {
        valid = 1
        formObject.relationshipProject.projectParentId.error = i18n?.global.t('error.0111', userLocale)
      }
    })
  }
  if (formObject.relationship.type.content === 'kpi') {
    const ObjectiveUuid = formObject.relationshipKPI.kpiParentId.content
    selectedStrategy.relationships.forEach((relationship) => {
      if (relationship.kpiUuid === ObjectiveUuid) {
        valid = 1
        formObject.relationshipKPI.kpiParentId.error = i18n?.global.t('error.0111', userLocale)
      }
    })
  }

  return valid
}
